import { Pipe, PipeTransform } from '@angular/core'
import { LocalDate, Timestamp } from '@lemon/core/model/common'
import { CurrencyService } from '@lemon/core/service/currency.service'
import { DateService } from '@lemon/core/service/date.service'
import { TimestampService } from '../service/timestamp-service'

@Pipe({
  name: 'ljson',
  standalone: false,
})
export class PrettyPrintJsonPipe implements PipeTransform {
  constructor(
    private currencyService: CurrencyService,
    private dateService: DateService,
    private timestampService: TimestampService,
  ) {}

  transform(val) {
    if (val === undefined) {
      return 'undefined'
    }
    if (val === null) {
      return 'null'
    }
    return JSON.stringify(
      val,
      (key: string, value: any): any => {
        if (this.onkoTimestamp(value)) {
          if (value.toDate) {
            return this.dateService.muotoilePaivaJaAikaDate((value as Timestamp).toDate(), 'fi')
          } else {
            const timestamp = this.timestampService.newTimestamp(value.seconds, value.nanoseconds)
            return this.dateService.muotoilePaivaJaAikaDate(timestamp.toDate(), 'fi')
          }
        }
        if (this.onkoLocalDate(value)) {
          return this.dateService.muotoilePaikallinenPaiva(value as LocalDate, 'fi')
        }
        return value
      },
      2,
    )
      .replace(/ /g, '&nbsp;')
      .replace(/(?:\r\n|\r|\n)/g, '<br/>')
  }

  onkoTimestamp(value: any): boolean {
    return value && Object.keys(value).length === 2 && this.currencyService.onkoNumero(value.seconds) && this.currencyService.onkoNumero(value.nanoseconds)
  }

  onkoLocalDate(value: any): boolean {
    return value && Object.keys(value).length === 3 && this.currencyService.onkoNumero(value.day) && this.currencyService.onkoNumero(value.month) && this.currencyService.onkoNumero(value.year)
  }
}
